import type { FC } from "react";

import { FieldTextArea } from "@/components/form";
import FormComponentTitle from "@/components/form/form-component-title";
import type { UpdateFieldProps } from "@/components/form/patient/update-form";
import { Separator } from "@/components/ui/separator";
import { updatePatientSchema } from "@/schemas/patient";

const HygieneForm: FC<UpdateFieldProps> = ({ formApi }) => {
  return (
    <div className="flex flex-col gap-4 w-full">
      <FormComponentTitle
        title="Hygiène de vie"
        subTitle="Ajouter les informations du patient"
      />
      <Separator />
      <div className="flex gap-8">
        <label className="text-sm font-semibold text-gray-700 lg:w-full lg:max-w-[280px] flex-shrink-0">
          Sport
        </label>
        <FieldTextArea
          Field={formApi.Field}
          schema={updatePatientSchema}
          name="sportsComment"
          className="w-full lg:max-w-[512px]"
          placeholder="Écrire..."
          validators={{
            onChange: updatePatientSchema.shape.sportsComment,
          }}
        />
      </div>
      <Separator />
      <div className="flex gap-8">
        <label className="text-sm font-semibold text-gray-700 lg:w-full lg:max-w-[280px] flex-shrink-0">
          Alimentation
        </label>
        <FieldTextArea
          Field={formApi.Field}
          schema={updatePatientSchema}
          name="dietComment"
          className="w-full lg:max-w-[512px]"
          placeholder="Écrire..."
          validators={{
            onChange: updatePatientSchema.shape.dietComment,
          }}
        />
      </div>
    </div>
  );
};

export default HygieneForm;
